export enum MACRO_DELIMITERS {
  START = '{',
  END = '}',
}

// keys de macros con significado prestablecido para provider
export enum PROVIDER_MACROS_KEYS {
  CLICK_ID = 'click_id',
  PUBLISHER = 'publisher',
}

// keys de macros conocidas para skudo
export enum SKUDO_MACROS_KEYS {
  CLICK_ID = 'click_id',
  OFFER_ID = 'offer_id',
  PUBLISHER = 'publisher',
  SITE_ID = 'site_id',
  CAMPAIGN_ID = 'campaign_id',
  EVENT_ID = 'event_id',
  RANDOM = 'random',
  SERIAL = 'serial',
  OS_GROUP = 'os_group',
  DEVICE_TYPE = 'device_type',
  URL_ID = 'url_id',
}

export enum OFFER_REDIRECT_MACROS_KEYS {
  EXTERNAL_ID = 'external_id',
  RANDOM = 'random',
  CAMPAIGN_NAME = 'campaign_name',
  OFFER_NAME = 'offer_name',
  PUBLISHER = 'publisher',
  IP = 'ip',
  LANGUAGE = 'language',
  COUNTRY = 'country',
  CLICK_ID = 'click_id',
  OFFER_ID = 'offer_id',
  CAMPAIGN_ID = 'campaign_id',
  SITE_ID = 'site_id',
  TIMESTAMP = 'timestamp',
  OS_GROUP = 'os_group',
  DEVICE_TYPE = 'device_type',
  URL_ID = 'url_id',
}

export const MANDATORY_PROVIDER_PARAMS = new Set<string>([PROVIDER_MACROS_KEYS.CLICK_ID]);

export const FIRST_PARTY_COOKIE_PARAM = 'sk_click_id';
